function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-f1c6b85c\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector?type=styles&index=0!./form-file.vue")
}
var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./form-file.vue"),
  /* template */
  null,
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/form-file/form-file.vue
// module id = 700
// module chunks = 0